'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var PropTypes = require('prop-types');
var lanl_logo_inline = require('../../../assets/svg/lanl_logo.inline.svg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var LanlLogo = function LanlLogo(_ref) {
  var animLogo = _ref.animLogo;
  var _useState = React.useState(false),
    _useState2 = slicedToArray.default(_useState, 2),
    logoHover = _useState2[0],
    setLogoHover = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = slicedToArray.default(_useState3, 2),
    delayHandler = _useState4[0],
    setDelayHandler = _useState4[1];
  var handleMouseEnter = function handleMouseEnter() {
    setDelayHandler(setTimeout(function () {
      setLogoHover(true);
    }, 200));
  };
  var handleMouseLeave = function handleMouseLeave() {
    clearTimeout(delayHandler);
    setLogoHover(false);
  };
  return /*#__PURE__*/React__default.default.createElement("a", {
    href: "https://www.lanl.gov",
    "aria-label": "lanl logo",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, !logoHover && /*#__PURE__*/React__default.default.createElement(lanl_logo_inline.default, {
    className: "lanl-header-lanl-logo"
  }), logoHover && animLogo);
};
LanlLogo.propTypes = {
  animLogo: PropTypes__default.default.node
};

exports.LanlLogo = LanlLogo;
exports.default = LanlLogo;
//# sourceMappingURL=index.js.map
